// Catálogo da tela Relatórios e Indicadores: cada relatório pronto já sabe a fonte, as colunas, os filtros que
// fazem sentido e o agrupamento do gráfico. O usuário só escolhe período/cliente e gera (na tela ou em planilha).
// Os relatórios customizados cadastrados pelo admin entram no mesmo catálogo (definicaoCustomizada).

// Nome de exibição das colunas que a consulta devolve sem acento (vai para a tabela e para a planilha)
export const ROTULOS_COLUNAS = {
    "Codigo Cliente": "Código Cliente",
    "Data Formalizacao": "Data Formalização",
    "Situacao Acordo": "Situação Acordo",
    "Situacao Parcela": "Situação Parcela",
    "Acrescimo Baixa Parcela": "Acréscimo Baixa Parcela",
    "Data Distribuicao": "Data Distribuição",
    "Situacao Ficha": "Situação Ficha",
    "ID Ocorrencia": "ID Ocorrência",
    "Operador Ocorrencia": "Operador Ocorrência",
    "Tipo Ocorrencia": "Tipo Ocorrência",
    "Data Ocorrencia": "Data Ocorrência",
    "Observacao": "Observação",
    "Titulo": "Título",
    "Descricao": "Descrição",
    "Emissao": "Data Emissão",
    "Criacao": "Data Cadastro",
    "Devolucao": "Data Devolução",
    "Situacao Contrato": "Situação Contrato",
    "Nosso Numero": "Nosso Número",
    "DV Nosso Numero": "DV Nosso Número",
    "Pagamento": "Data Pagamento",
    "Linha Digitavel": "Linha Digitável",
    "Situacao Boleto": "Situação Boleto",
};

export const rotuloColuna = (coluna, aliases) => (aliases && aliases[coluna]) || ROTULOS_COLUNAS[coluna] || coluna;

// Um acordo por linha: sem colunas de parcela a consulta não junta as parcelas (não repete o acordo)
const COLUNAS_ACORDO = ["ID Acordo", "Devedor Nome", "Devedor Documento", "Cliente Nome", "Codigo Cliente", "Carteira",
    "Operador Acordo", "Campanha", "Data Formalizacao", "Valor Original", "Valor Acordo", "Desconto", "Qtd Parcelas", "Situacao Acordo"];
const COLUNAS_PARCELA = ["ID Acordo", "Devedor Nome", "Devedor Documento", "Cliente Nome", "Operador Acordo", "Data Formalizacao",
    "Valor Acordo", "Num Parcela", "Valor Parcela", "Vencimento Parcela", "Situacao Parcela"];
const COLUNAS_OCORRENCIA = ["ID Ocorrencia", "Devedor Nome", "Devedor Documento", "Cliente Nome", "Carteira", "Operador Ocorrencia",
    "Tipo Ocorrencia", "Data Ocorrencia", "Observacao"];
const COLUNAS_FICHA = ["ID Devedor", "Devedor Nome", "Devedor Documento", "Cliente Nome", "Codigo Cliente", "Carteira", "Status Ficha",
    "Operador Ficha", "Data Distribuicao", "Situacao Ficha"];
const COLUNAS_CONTRATO = ["ID Contrato", "Titulo", "Parcela", "Devedor Nome", "Devedor Documento", "Cliente Nome", "Carteira",
    "Valor Original", "Saldo", "Vencimento", "Situacao Contrato"];
const COLUNAS_BOLETO = ["ID Boleto", "Nosso Numero", "Devedor Nome", "Devedor Documento", "Cliente Nome", "Valor Boleto", "Valor Pago",
    "Vencimento", "Pagamento", "Emissao", "Situacao Boleto"];

// Base inteira é grande demais para a tela e para uma planilha: exige ao menos um destes filtros
const RECORTE_BASE = ["clientes", "carteiras", "operadores"];

export const GRUPOS_RELATORIOS = [
    { id: "acordos", titulo: "Acordos e parcelas", icone: "handshake", cor: "#2E7D32", corEscura: "#81C784" },
    { id: "atendimento", titulo: "Atendimento", icone: "support_agent", cor: "#1565C0", corEscura: "#64B5F6" },
    { id: "base", titulo: "Base de cobrança", icone: "folder_shared", cor: "#6A1B9A", corEscura: "#CE93D8" },
    { id: "financeiro", titulo: "Boletos", icone: "request_quote", cor: "#B26A00", corEscura: "#FFB74D" },
    { id: "escritorio", titulo: "Relatórios do escritório", icone: "description", cor: "#00695C", corEscura: "#4DB6AC" },
];

export const RELATORIOS_PRONTOS = [
    {
        id: "acordos_periodo", grupo: "acordos", icone: "handshake", fonte: "acordos", colunas: COLUNAS_ACORDO,
        titulo: "Acordos do período",
        descricao: "Acordos formalizados no período, com valor, desconto e situação.",
        filtros: ["periodo", "clientes", "operadores", "situacoes"], rotuloPeriodo: "Data da formalização", periodoPadrao: "mes_atual",
        grafico: { groupColumn: "Situacao Acordo", aggregateType: "sum", aggregateColumn: "Valor Acordo", chartType: "pie" },
    },
    {
        id: "acordos_operador", grupo: "acordos", icone: "badge", fonte: "acordos", colunas: COLUNAS_ACORDO,
        titulo: "Acordos por operador",
        descricao: "Quantos acordos cada operador fechou e o valor total.",
        filtros: ["periodo", "clientes", "operadores", "situacoes"], rotuloPeriodo: "Data da formalização", periodoPadrao: "mes_atual",
        grafico: { groupColumn: "Operador Acordo", aggregateType: "sum", aggregateColumn: "Valor Acordo", chartType: "hbar" },
    },
    {
        id: "acordos_cliente", grupo: "acordos", icone: "domain", fonte: "acordos", colunas: COLUNAS_ACORDO,
        titulo: "Acordos por cliente",
        descricao: "Volume e valor dos acordos de cada cliente.",
        filtros: ["periodo", "clientes", "operadores", "situacoes"], rotuloPeriodo: "Data da formalização", periodoPadrao: "mes_atual",
        grafico: { groupColumn: "Cliente Nome", aggregateType: "sum", aggregateColumn: "Valor Acordo", chartType: "hbar" },
    },
    {
        id: "acordos_aberto", grupo: "acordos", icone: "pending_actions", fonte: "acordos", colunas: COLUNAS_ACORDO,
        titulo: "Acordos em aberto",
        descricao: "Acordos pendentes de pagamento, de qualquer data.",
        filtros: ["periodo", "clientes", "operadores"], rotuloPeriodo: "Data da formalização", periodoPadrao: "todos",
        fixos: { situations: [1] }, descricaoFixa: ["Situação do acordo: Pendente"],
        grafico: { groupColumn: "Operador Acordo", aggregateType: "sum", aggregateColumn: "Valor Acordo", chartType: "hbar" },
    },
    {
        id: "parcelas_vencer", grupo: "acordos", icone: "event_upcoming", fonte: "acordos", colunas: COLUNAS_PARCELA,
        titulo: "Parcelas a vencer",
        descricao: "Parcelas pendentes com vencimento de hoje em diante.",
        filtros: ["clientes", "operadores"],
        fixos: { apenasAVencer: true }, descricaoFixa: ["Somente parcelas pendentes a vencer"],
        grafico: { groupColumn: "Cliente Nome", aggregateType: "sum", aggregateColumn: "Valor Parcela", chartType: "hbar" },
    },
    {
        id: "parcelas_atraso", grupo: "acordos", icone: "running_with_errors", fonte: "acordos", colunas: COLUNAS_PARCELA,
        titulo: "Parcelas em atraso",
        descricao: "Parcelas pendentes com vencimento já passado.",
        filtros: ["clientes", "operadores"],
        fixos: { apenasAtrasadas: true }, descricaoFixa: ["Somente parcelas pendentes em atraso"],
        grafico: { groupColumn: "Operador Acordo", aggregateType: "sum", aggregateColumn: "Valor Parcela", chartType: "hbar" },
    },
    {
        id: "ocorrencias_periodo", grupo: "atendimento", icone: "forum", fonte: "ocorrencias", colunas: COLUNAS_OCORRENCIA,
        titulo: "Ocorrências do período",
        descricao: "Contatos e ações registrados nas fichas, por tipo de ocorrência.",
        filtros: ["periodo", "clientes", "operadores", "tiposOcorrencia"], rotuloPeriodo: "Data da ocorrência", periodoPadrao: "ultimos_7",
        grafico: { groupColumn: "Tipo Ocorrencia", aggregateType: "count", aggregateColumn: "ID Ocorrencia", chartType: "hbar" },
    },
    {
        id: "ocorrencias_operador", grupo: "atendimento", icone: "support_agent", fonte: "ocorrencias", colunas: COLUNAS_OCORRENCIA,
        titulo: "Ocorrências por operador",
        descricao: "Quantas ocorrências cada operador registrou no período.",
        filtros: ["periodo", "clientes", "operadores", "tiposOcorrencia"], rotuloPeriodo: "Data da ocorrência", periodoPadrao: "hoje",
        grafico: { groupColumn: "Operador Ocorrencia", aggregateType: "count", aggregateColumn: "ID Ocorrencia", chartType: "hbar" },
    },
    {
        id: "fichas_carteira", grupo: "base", icone: "folder_shared", fonte: "devedores", colunas: COLUNAS_FICHA,
        titulo: "Fichas por carteira",
        descricao: "Fichas da base agrupadas por carteira.",
        filtros: ["clientes", "carteiras", "operadores", "status"], exigeUmDe: RECORTE_BASE,
        grafico: { groupColumn: "Carteira", aggregateType: "count", aggregateColumn: "ID Devedor", chartType: "hbar" },
    },
    {
        id: "fichas_status", grupo: "base", icone: "donut_small", fonte: "devedores", colunas: COLUNAS_FICHA,
        titulo: "Fichas por status",
        descricao: "Distribuição das fichas pelo status configurado.",
        filtros: ["clientes", "carteiras", "operadores", "status"], exigeUmDe: RECORTE_BASE,
        grafico: { groupColumn: "Status Ficha", aggregateType: "count", aggregateColumn: "ID Devedor", chartType: "pie" },
    },
    {
        id: "fichas_operador", grupo: "base", icone: "groups", fonte: "devedores", colunas: COLUNAS_FICHA,
        titulo: "Fichas por operador",
        descricao: "Quantas fichas estão com cada operador.",
        filtros: ["clientes", "carteiras", "operadores", "status"], exigeUmDe: RECORTE_BASE,
        grafico: { groupColumn: "Operador Ficha", aggregateType: "count", aggregateColumn: "ID Devedor", chartType: "hbar" },
    },
    {
        id: "titulos_vencimento", grupo: "base", icone: "receipt_long", fonte: "contratos", colunas: COLUNAS_CONTRATO,
        titulo: "Títulos por vencimento",
        descricao: "Contratos/títulos com vencimento no período, com saldo e situação.",
        filtros: ["periodo", "clientes", "carteiras"], rotuloPeriodo: "Vencimento do título", periodoPadrao: "mes_atual",
        grafico: { groupColumn: "Situacao Contrato", aggregateType: "sum", aggregateColumn: "Saldo", chartType: "pie" },
    },
    {
        id: "boletos_periodo", grupo: "financeiro", icone: "request_quote", fonte: "boletos", colunas: COLUNAS_BOLETO,
        titulo: "Boletos do período",
        descricao: "Boletos com vencimento no período: emitidos, pagos, baixados e cancelados.",
        filtros: ["periodo", "clientes"], rotuloPeriodo: "Vencimento do boleto", periodoPadrao: "mes_atual",
        grafico: { groupColumn: "Situacao Boleto", aggregateType: "sum", aggregateColumn: "Valor Boleto", chartType: "pie" },
    },
];

// Parâmetros que o SQL de um relatório customizado pode usar e o filtro da tela que os preenche
const PARAMETROS_CUSTOMIZADOS = [
    { parametros: ["startDate", "endDate"], filtro: "periodo" },
    { parametros: ["clienteIds", "clienteId", "cvIdPessoa"], filtro: "clientes" },
    { parametros: ["userIds"], filtro: "operadores" },
    { parametros: ["carteiraIds"], filtro: "carteiras" },
    { parametros: ["statusFichaIds"], filtro: "status" },
    { parametros: ["tipoOcorrenciaIds"], filtro: "tiposOcorrencia" },
    { parametros: ["situations"], filtro: "situacoes" },
];

export const PARAMETROS_SQL_AJUDA = ":startDate e :endDate (período), :clienteIds, :userIds (operadores), :carteiraIds, "
    + ":statusFichaIds, :tipoOcorrenciaIds e :situations";

/** Relatório customizado (cadastrado pelo admin) no formato do catálogo: os filtros saem dos parâmetros do SQL. */
export function definicaoCustomizada(item) {
    // Parâmetros ":nome" do SQL (fora de textos entre aspas)
    const sql = (item.ccQuerySql || "").replace(/'([^']|'')*'/g, "''");
    const usados = new Set(Array.from(sql.matchAll(/(^|[^:\w]):([A-Za-z_]\w*)/g), m => m[2]));
    const usa = (p) => usados.has(p);
    const filtros = PARAMETROS_CUSTOMIZADOS.filter(p => p.parametros.some(usa)).map(p => p.filtro);
    return {
        id: `custom_${item.cvId}`,
        grupo: "escritorio",
        icone: "description",
        fonte: `custom_${item.cvId}`,
        colunas: [],
        titulo: item.ccNome,
        descricao: item.ccDescricao || "Relatório cadastrado pelo escritório.",
        filtros,
        // Parâmetro do SQL sem valor não roda: todo filtro que o SQL usa é obrigatório
        obrigatorios: filtros,
        periodoPadrao: filtros.includes("periodo") ? "mes_atual" : undefined,
        rotuloPeriodo: "Período",
        customizado: true,
        temTemplate: Boolean(item.ccTemplateArquivo),
    };
}

// ---------- Período ----------

export const PERIODOS = [
    { id: "hoje", label: "Hoje" },
    { id: "ontem", label: "Ontem" },
    { id: "ultimos_7", label: "Últimos 7 dias" },
    { id: "mes_atual", label: "Este mês" },
    { id: "mes_passado", label: "Mês passado" },
    { id: "ano_atual", label: "Este ano" },
    { id: "personalizado", label: "Outro período" },
];
export const PERIODO_QUALQUER = { id: "todos", label: "Qualquer data" };

const pad = (n) => String(n).padStart(2, "0");
export const isoData = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
export const dataBr = (iso) => (iso ? iso.split("-").reverse().join("/") : "");

/** { inicio, fim } em yyyy-MM-dd para o período escolhido; "todos" = sem datas. */
export function intervaloDoPeriodo(periodo, inicioPersonalizado, fimPersonalizado, hoje = new Date()) {
    const d = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate());
    switch (periodo) {
        case "hoje": return { inicio: isoData(d), fim: isoData(d) };
        case "ontem": {
            const o = new Date(d); o.setDate(o.getDate() - 1);
            return { inicio: isoData(o), fim: isoData(o) };
        }
        case "ultimos_7": {
            const i = new Date(d); i.setDate(i.getDate() - 6);
            return { inicio: isoData(i), fim: isoData(d) };
        }
        case "mes_atual": return { inicio: isoData(new Date(d.getFullYear(), d.getMonth(), 1)), fim: isoData(d) };
        case "mes_passado": return {
            inicio: isoData(new Date(d.getFullYear(), d.getMonth() - 1, 1)),
            fim: isoData(new Date(d.getFullYear(), d.getMonth(), 0)),
        };
        case "ano_atual": return { inicio: isoData(new Date(d.getFullYear(), 0, 1)), fim: isoData(d) };
        case "personalizado": return { inicio: inicioPersonalizado || "", fim: fimPersonalizado || "" };
        default: return { inicio: "", fim: "" };
    }
}

// ---------- Opções dos filtros (mesmos campos que o assistente usa) ----------

export const rotuloOperador = (o) => o.nome || o.ccNome || o.name || o.ccLogin || (o.id ? `Operador ${o.id}` : "");
export const rotuloCliente = (c) => c.nomeComum || c.nomeCompleto || c.ccNomeComum || c.ccNomeCompleto || c.nome || c.name || (c.id ? `Cliente ${c.id}` : "");
export const rotuloCarteira = (c) => c.nome || c.ccNome || c.name || (c.id ? `Carteira ${c.id}` : "");
export const rotuloStatus = (s) => s.ccNome || s.nome || s.name || (s.id ? `Status ${s.id}` : "");
export const rotuloTipoOcorrencia = (t) => t.nome || t.ccNome || t.name || (t.id ? `Ocorrência ${t.id}` : "");
export const rotuloSituacao = (s) => s.name || s.label || s.nome || `Situação ${s.id}`;

export const FILTROS = {
    clientes: { label: "Cliente", plural: "Clientes", placeholder: "Todos os clientes", rotulo: rotuloCliente, valor: (c) => c.id || c.cvId, lista: "clientes" },
    operadores: { label: "Operador", plural: "Operadores", placeholder: "Todos os operadores", rotulo: rotuloOperador, valor: (o) => o.id || o.cvCodUsuario || o.cvId, lista: "operadores" },
    carteiras: { label: "Carteira", plural: "Carteiras", placeholder: "Todas as carteiras", rotulo: rotuloCarteira, valor: (c) => c.id || c.cvId, lista: "carteiras" },
    status: { label: "Status da ficha", plural: "Status da ficha", placeholder: "Todos os status", rotulo: rotuloStatus, valor: (s) => s.id || s.cvId, lista: "status" },
    situacoes: { label: "Situação do acordo", plural: "Situação do acordo", placeholder: "Todas as situações", rotulo: rotuloSituacao, valor: (s) => s.id, lista: "situacoes" },
    tiposOcorrencia: { label: "Tipo de ocorrência", plural: "Tipos de ocorrência", placeholder: "Todos os tipos", rotulo: rotuloTipoOcorrencia, valor: (t) => t.id || t.cvId, lista: "tiposOcorrencia" },
};

export const opcoesDe = (chave, lista) => (lista || []).map(item => ({ ...item, value: FILTROS[chave].valor(item), label: FILTROS[chave].rotulo(item) }));

// ---------- Filtros para o backend e descrição para a planilha ----------

/** Corpo "filtros" de /reports/run e /reports/export-xlsx a partir do que foi escolhido no diálogo. */
export function montarFiltros(def, sel) {
    const { inicio, fim } = intervaloDoPeriodo(sel.periodo, sel.inicio, sel.fim);
    const fixos = def.fixos || {};
    return {
        startDate: def.filtros.includes("periodo") ? inicio : "",
        endDate: def.filtros.includes("periodo") ? fim : "",
        userIds: (sel.operadores || []).map(o => o.cvCodUsuario || o.id || o.cvId),
        statusFichaIds: (sel.status || []).map(s => s.cvId || s.id),
        carteiraIds: (sel.carteiras || []).map(c => c.cvId || c.id),
        situations: fixos.situations || (sel.situacoes || []).map(s => s.id),
        tipoOcorrenciaIds: (sel.tiposOcorrencia || []).map(t => t.cvId || t.id),
        clienteIds: (sel.clientes || []).map(c => c.id || c.cvId),
        excetoDevolvidos: false,
        semAtraso: false,
        apenasAVencer: Boolean(fixos.apenasAVencer),
        apenasAtrasadas: Boolean(fixos.apenasAtrasadas),
        selectedColumns: def.colunas || [],
        columnAliases: {},
    };
}

function listaCurta(itens, rotulo) {
    const nomes = itens.map(rotulo).filter(Boolean);
    return nomes.length > 5 ? `${nomes.slice(0, 5).join(", ")} e mais ${nomes.length - 5}` : nomes.join(", ");
}

/** Filtros aplicados em texto, para o topo da planilha e para a tela de resultado. */
export function descreverFiltros(def, sel) {
    const partes = [];
    if (def.filtros.includes("periodo")) {
        const { inicio, fim } = intervaloDoPeriodo(sel.periodo, sel.inicio, sel.fim);
        if (inicio || fim) partes.push(`${def.rotuloPeriodo || "Período"}: ${dataBr(inicio) || "início"} a ${dataBr(fim) || "hoje"}`);
    }
    Object.keys(FILTROS).forEach(chave => {
        const itens = sel[chave] || [];
        if (def.filtros.includes(chave) && itens.length > 0) {
            partes.push(`${itens.length > 1 ? FILTROS[chave].plural : FILTROS[chave].label}: ${listaCurta(itens, FILTROS[chave].rotulo)}`);
        }
    });
    return [...partes, ...(def.descricaoFixa || [])];
}

/** Mensagem do que falta escolher, ou null quando dá para gerar. */
export function validarSelecao(def, sel) {
    const obrigatorios = def.obrigatorios || [];
    if (def.filtros.includes("periodo")) {
        const { inicio, fim } = intervaloDoPeriodo(sel.periodo, sel.inicio, sel.fim);
        if (sel.periodo === "personalizado" && inicio && fim && inicio > fim) return "A data inicial é depois da data final.";
        if ((obrigatorios.includes("periodo") || sel.periodo === "personalizado") && (!inicio || !fim)) {
            return "Informe a data inicial e a data final.";
        }
    }
    const faltando = obrigatorios.filter(f => f !== "periodo" && !(sel[f] || []).length).map(f => FILTROS[f].label.toLowerCase());
    if (faltando.length) return `Este relatório precisa do filtro: ${faltando.join(", ")}.`;
    if (def.exigeUmDe && !def.exigeUmDe.some(f => (sel[f] || []).length)) {
        return `Escolha ao menos ${def.exigeUmDe.map(f => FILTROS[f].label.toLowerCase()).join(", ").replace(/, ([^,]*)$/, " ou $1")}: a base inteira é grande demais para gerar de uma vez.`;
    }
    return null;
}

export const selecaoInicial = (def) => ({
    periodo: def.periodoPadrao || (def.filtros.includes("periodo") ? "mes_atual" : "todos"),
    inicio: "",
    fim: "",
    clientes: [],
    operadores: [],
    carteiras: [],
    status: [],
    situacoes: [],
    tiposOcorrencia: [],
});

/** "acordos_por_operador_20261003_1432.xlsx" */
export function nomeArquivo(titulo, agora = new Date()) {
    const base = (titulo || "relatorio").normalize("NFD").replace(/\p{M}/gu, "").replace(/[^a-zA-Z0-9]+/g, "_").replace(/^_|_$/g, "").toLowerCase();
    return `${base || "relatorio"}_${agora.getFullYear()}${pad(agora.getMonth() + 1)}${pad(agora.getDate())}_${pad(agora.getHours())}${pad(agora.getMinutes())}.xlsx`;
}

/** Busca no catálogo: título, descrição e grupo, sem diferenciar acentos. */
export function correspondeBuscaRelatorio(def, termo) {
    const norm = (s) => (s || "").normalize("NFD").replace(/\p{M}/gu, "").toLowerCase();
    const t = norm(termo).trim();
    if (!t) return true;
    const grupo = GRUPOS_RELATORIOS.find(g => g.id === def.grupo);
    return [def.titulo, def.descricao, grupo?.titulo].some(c => norm(c).includes(t));
}
